import { EMPTY_OBJECT } from '../../../../constants/common'

/**
 * @param {string} name
 * @param {*} value
 * @param {React.ComponentType} Control
 * @param {Object} defaultProps
 */
export function control(name, value, Control, defaultProps = EMPTY_OBJECT) {
  return {
    Control: props => <Control {...{ ...defaultProps, ...props }} />,
    name,
    omitted: false,
    value,
  }
}
